export default {
    firstToCreate: '이 포럼에서 첫 번째로 스레드를 만들어보세요',
    firstToPostInCategory: '이 카테고리에서 첫 번째로 게시하세요',
    firstToRespondToTopic: '이 주제에 첫 번째로 응답하세요!',
    createNewThread: '새 스레드 만들기',
    thread: '스레드',
    viewThread: '스레드 보기',
    replies: '답글',
    noReplies: '답글 없음',
    reply: '답글',
    _reply: '답글 달기',
    ReplyTo: '답글 달기',
    replyToThisQuestion: '이 질문에 답글 달기',
    onceRepliedModeratorMayRespond: '답글을 남기면 포럼 운영자가 응답할 수 있습니다',
    onceRepliedCanViewResponses: '답글을 남기면 다른 참가자의 응답을 볼 수 있습니다',
    loadingResponses: '응답 불러오는 중',
    hideXReplies: '{count}개의 답글 숨기기',
    showXReplies: '{count}개의 답글 보기',
    hideMostRecentReplies: '최신 답글 숨기기',
    showMostRecentReplies: '최신 답글 보기',
    post: '게시',
    message: '메시지',
    typeMessage: '메시지를 입력하세요',
    addPost: '게시 추가',
    addMessage: '메시지 추가',
    editPost: '게시 수정',
    editPostWithMedia: '미디어가 포함된 게시 수정',
    createPostWithMedia: '미디어가 포함된 게시 작성',
    deleteMessage: '메시지 삭제',
    deleteMessageConfirm: '이 메시지를 삭제하시겠습니까?',
    pinPost: '게시 고정',
    media: '미디어',
    uploadMedia: '미디어 업로드',
    categories: '카테고리',
    goBack: '뒤로 가기',
    goBackPrevious: '이전 페이지로 돌아가기',
    goBackToCategory: '{name} 카테고리로 돌아가기',
    loadingLatestThreads: '최신 스레드 불러오는 중',
    loadingDiscussionForum: '토론 포럼 불러오는 중',
    dontShowAgainForTask: '이 작업에 대해 다시 표시하지 않기',
    title: '제목',
    beTheFirst: 'Be the first to reply to this thread'
};
